import axiosConfig from "./axiosConfig";
import { Lead } from "./getLeads";

export interface LeadsBulkPremiumEnrichRequest {
  leadIds: string[];
}

export interface LeadsBulkPremiumEnrichSkipped {
  leadId: string;
  reason: string;
}

// Result shape the long-running operation writes back into DDB on
// completion. Not the immediate response from POST - the FE polls
// /operations/<key> and reads `result` once `status === "completed"`.
export interface LeadsBulkPremiumEnrichOperationResult {
  // Refreshed lead rows post-enrichment, in the same shape as
  // GET /leads.
  leads: Lead[];
  // Any leads that couldn't be enriched (e.g. non-VOA-sourced,
  // missing VOA row). Already-premium leads are *not* listed - they
  // are silently no-ops because the BE always returns them in
  // `leads` with their existing data.
  skipped: LeadsBulkPremiumEnrichSkipped[];
}

// Immediate response from POST /leads/bulk-premium-enrich: the
// operation key + siteId the FE needs to poll for completion. The
// actual enrichment work happens in the long-running-operation Lambda;
// the FE polls /operations/{key}?siteId=... until status is
// completed/failed. Was previously a synchronous endpoint but blew
// past the 29s API Gateway ceiling on larger batches.
export interface LeadsBulkPremiumEnrichPendingResponse {
  status: "pending";
  operationKey: string;
  siteId: string;
  leadCount: number;
}

const postLeadsBulkPremiumEnrich = async (
  authToken: string,
  body: LeadsBulkPremiumEnrichRequest
): Promise<LeadsBulkPremiumEnrichPendingResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/bulk-premium-enrich`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadsBulkPremiumEnrich;
